import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './app'
import { installChunkReloadHandler } from './app/installChunkReloadHandler'
import { installCfdPushBridge } from '@features/push'

const root = document.getElementById('root')
if (!root) throw new Error('Root element not found')

installChunkReloadHandler()
installCfdPushBridge()

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
)
